<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      :items-per-page="20"
      class="elevation-1"
    >
      <template v-slot:item.image_url="{ item }">
        <div class="flex-center justify-center">
          <span
            @click="openImage(item.image_url)"
            v-show="item.image_url"
            class="px-2"
          >
            <div class="py-1">
              <v-img
                class="image-cover"
                width="50px"
                height="50px"
                :src="item.image_url"
                alt=""
              ></v-img>
            </div>
          </span>

          <span
            @click="openImage(item.image_url2)"
            v-show="item.image_url2"
            class="px-2"
          >
            <div class="py-1">
              <v-img
                class="image-cover"
                width="50px"
                height="50px"
                :src="item.image_url2"
                alt=""
              ></v-img>
            </div>
          </span>

          <span
            @click="openImage(item.image_url3)"
            v-show="item.image_url3"
            class="px-2"
          >
            <div class="py-1">
              <v-img
                class="image-cover"
                width="50px"
                height="50px"
                :src="item.image_url3"
                alt=""
              ></v-img>
            </div>
          </span>
        </div>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      width="fit-content"
      max-width="90dvw"
      @keydown.esc="cancel"
    >
      <v-card class="py-4 px-4">
        <image-zoom
          :regular="pic"
          :zoom-amount="4"
          :click-zoom="true"
          img-class="img-fluid-zoom"
          close-pos="top-right"
          message-pos="top"
        ></image-zoom>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },

  data() {
    return {
      footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
      dialog: false,
      pic: '',
      headers: [
        {
          text: 'โปรดักโค้ด',
          align: 'start',
          sortable: false,
          value: 'sku',
        },
        { text: 'ซีเรียล', value: 'serial', align: 'start' },
        { text: 'จำนวนสต๊อก', value: 'amount', align: 'end' },
        {
          text: 'จำนวนตรวจเช็ค',
          value: 'amount_checked',
          align: 'end',
        },
        { text: 'รูปภาพ', value: 'image_url', align: 'center' },
        {
          text: 'รายละเอียด',
          value: 'description_type',
          align: 'center',
        },
        {
          text: 'อัพเดทเวลา',
          value: 'updated_timestamp',
          align: 'start',
        },
        {
          text: 'พนักงาน',
          align: 'start',
          sortable: false,
          value: 'emp_name',
        },
      ],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
    }
  },

  methods: {
    openImage(imageUrl) {
      if (imageUrl) {
        this.pic = imageUrl
        this.dialog = true
      }
    },
    getScanBarcode(val) {
      return val === 1
    },
  },
}
</script>

<style>
.image-cover {
  cursor: pointer;
  object-fit: cover;
  border-radius: 4px;
}
</style>
